import { action } from 'easy-peasy';
import { IActionAddIcd10Codes } from '../types';

const addIcd10Codes: IActionAddIcd10Codes = action((state, payload) => {
  state.items = [...payload, ...state.items];
});

export default addIcd10Codes;
